var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"like-wrapper",on:{"click":function($event){$event.preventDefault();return _vm.onClick()}}},[(_vm.showIcon)?_c('i',{class:_vm.cssClasses}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }